export const buildTime = '2026-10-12 14:12:41 UTC';
